
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nearby-resorts",
      function () {
        return require("private-next-pages/nearby-resorts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nearby-resorts"])
      });
    }
  